// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/papier_parchemin.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/cadre_parchemin.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #030303;
  color: white;
}

a {
  color: #de8909;
  text-decoration: none;
  font-weight: 700;
}

/********************************************/
/*          Font Family & Typography        */
/********************************************/
.navbar-nav .nav-link,
footer h3 {
  font-family: 'Cinzel', serif;
  font-size: 21px;
  font-weight: 400;
}

body,
p {
  font-family: 'Cormorant Garamond', serif;
  font-weight: 500;
  font-size: 18px;
}

button,
.btn {
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  font-size: 16px;
}

h1 {
  font-family: 'Cinzel', serif;
  font-size: 30px;
  text-align: center;
  margin-bottom: 20px;
  ;
}

h2 {
  font-family: 'Dancing Script', serif;
  font-size: 2.2rem;
  margin-bottom: 20px;
}

h3 {
  font-family: 'Cinzel', serif;
  font-weight: 600;
  font-size: 18px;
  text-transform: uppercase;
}

h4 {
  font-family: 'Cinzel', serif;
  font-weight: 400;
  text-transform: uppercase;
}

.italic-semibold {
  font-family: 'Cormorant Garamond', serif;
  font-weight: 600;
  font-style: italic;
}

.subtitle {
  font-family: 'Dancing Script', serif;
  font-size: 40px;
  color: #030303;
}

/********************************************/
/*                    Base                  */
/********************************************/
#root {
  background: linear-gradient(to bottom, #201F41 0%, #201F41 1375px, #030303 2000px);
}

.beige {
  color: #F3ECD2
}

.app {
  width: 100%;
  min-height: 100vh;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
  display: flex;
  flex-direction: column;
  position: relative;
}

.text {
  background-color: #dfc6a9;
  color: #030303;
  padding: 20px;
}

/* Parchemin (images générées par scripts/parchemin.py) : le bloc garde une bordure transparente
   pour réserver la place du cadre ; ::before pose le papier (img/papier_parchemin.jpg), qui passe sous
   la partie intérieure du cadre sans atteindre la déchirure ; ::after dessine le cadre déchiré
   (img/cadre_parchemin.webp, coins 87x119, bord intérieur transparent) par-dessus.
   --papier-pos / --papier-sens : décalage et retournement du papier tirés au hasard pour chaque bloc
   (BackgroundWrapper.js), pour que deux blocs ne montrent pas le même dessin. */
.fondParchemin {
  --parchemin-haut: 70px;  /* épaisseur du cadre */
  --parchemin-cote: 51px;
  --papier-haut: 22px;     /* retrait du papier depuis le bord extérieur du cadre */
  --papier-cote: 26px;
  position: relative;
  isolation: isolate;      /* les pseudo-éléments en z-index -1 restent sous le contenu du bloc */
  color: #030303;
  padding: 10px 25px;
  border: solid transparent;
  border-width: var(--parchemin-haut) var(--parchemin-cote);
}

.fondParchemin::before,
.fondParchemin::after {
  content: '';
  position: absolute;
  z-index: -1;
  pointer-events: none;
}

.fondParchemin::before {
  inset: calc(var(--papier-haut) - var(--parchemin-haut)) calc(var(--papier-cote) - var(--parchemin-cote));
  background: #dfceb0 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) var(--papier-pos, 0 0);
  scale: var(--papier-sens, 1 1);
}

.fondParchemin::after {
  inset: calc(-1 * var(--parchemin-haut)) calc(-1 * var(--parchemin-cote));
  border-style: solid;
  border-width: var(--parchemin-haut) var(--parchemin-cote);
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 119 87 / var(--parchemin-haut) var(--parchemin-cote) round;
}

.fondParchemin .row {
  margin: 20px auto;
}

.textSpe {
  background-color: #dfc6a9;
  margin-top: -80px;
  padding-top: 80px;
  padding-bottom: 80px;
  margin-bottom: -80px;
  z-index: -1;
}

.espaceHaut {
  height: 38vh;
}

.codeBonus .espaceHaut {
  height: 8vh;
}

@media (max-width: 992px) {
  .codeBonus .espaceHaut {
    height: 5vh;
  }
}

footer {
  border-top: 1px solid #fff;
  padding-top: 25px;
  margin-top: 50px;
}

footer .container {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  margin-bottom: 10px;
}

.footerSecondaire {
  background-color: #dfc6a9;
  color: #030303;
  padding: 2px;
}

.footerBoutique {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.rowIcons {
  margin-top: 20px;
}

.enigmas-buttonsaaa {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

/********************************************/
/*                    Base                  */
/********************************************/
.mr-2 {
  margin-right: .5rem !important;
}

/********************************************/
/*                 BOUTON                   */
/********************************************/
.link-capsule {
  border: 1px solid gold;
  border-radius: 20px;
  padding: 0 10px;
}

.btn-right-cut {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

button,
.btn {
  /*couleurs de base pour bouton fond noir*/
  /*height: 40px;*/
  /* Hauteur fixe pour chaque bouton */
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0px 15px;
  padding: 8px 35px;
  border-radius: 50px;
  color: #F3ECD2;
  background-color: #030303;
  border: 1px solid #DAB166;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}

.btn:hover {
  color: #030303;
  background-color: #DAB166;
  border: 1px solid #030303;
}

.btn.btnBeige {
  color: #DE9709;
  background-color: #F3ECD2;
  border: 1px solid #DE9709;
}

.btn.btnOrange {
  color: #030303;
  background-color: #DAB166;
  border: 1px solid #030303;
}

.btnIcon {
  padding: 8px 10px 6px;
  border: 1px solid #DAB166;
  border-radius: 50px;
  color: #dfc6a9;
}

.btnIcon:hover {
  background-color: #DAB166;
  color: #030303;
}

/********************************************/
/*              Responsive                  */
/********************************************/
@media (max-width:1400px) {
  .espaceHaut {
    height: 35vh;
  }
}

@media (max-width:1200px) {
  .espaceHaut {
    height: 25vh;
  }
}

@media (max-width:992px) {
  .espaceHaut {
    height: 5vh;
  }
}

@media (max-width: 767px) {
  .fondParchemin {
    --parchemin-haut: 42px;
    --parchemin-cote: 31px;
    --papier-haut: 13px;
    --papier-cote: 16px;
    padding: 5px 8px;
  }

  .index-links {
    gap: 0;
    flex-direction: column;
  }

  footer {
    text-align: center;
    padding-top: 15px;
  }

  footer .btn {
    margin: 5px auto;
  }

  .fondParchemin .row {
    margin: 10px auto;
  }

  footer .container {
    margin-bottom: 20px;
  }

  /********************************************/
  /*               Page SPE                   */
  /********************************************/

  .page_fin,
  .page_Fin {
    background-color: black !important;
  }

  .page_fin2,
  .page_Fin2 {
    background-color: #16172d !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C,6CAA6C;AAC7C,6CAA6C;AAC7C;;EAEE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA,6CAA6C;AAC7C,6CAA6C;AAC7C,6CAA6C;AAC7C;EACE,kFAAkF;AACpF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;;;;;gFAKgF;AAChF;EACE,sBAAsB,GAAG,uBAAuB;EAChD,sBAAsB;EACtB,mBAAmB,MAAM,wDAAwD;EACjF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,OAAO,sEAAsE;EAC/F,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,wGAAwG;EACxG,kFAAkF;EAClF,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,mBAAmB;EACnB,yDAAyD;EACzD,gHAAgH;AAClH;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA,6CAA6C;AAC7C,6CAA6C;AAC7C,6CAA6C;AAC7C;EACE,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C,6CAA6C;AAC7C,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;;EAEE,yCAAyC;EACzC,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C,6CAA6C;AAC7C,6CAA6C;AAC7C;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,MAAM;IACN,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;;EAE7C;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,oCAAoC;EACtC;AACF","sourcesContent":["body {\n  background-color: #030303;\n  color: white;\n}\n\na {\n  color: #de8909;\n  text-decoration: none;\n  font-weight: 700;\n}\n\n/********************************************/\n/*          Font Family & Typography        */\n/********************************************/\n.navbar-nav .nav-link,\nfooter h3 {\n  font-family: 'Cinzel', serif;\n  font-size: 21px;\n  font-weight: 400;\n}\n\nbody,\np {\n  font-family: 'Cormorant Garamond', serif;\n  font-weight: 500;\n  font-size: 18px;\n}\n\nbutton,\n.btn {\n  font-family: 'Playfair Display', serif;\n  font-weight: 500;\n  font-size: 16px;\n}\n\nh1 {\n  font-family: 'Cinzel', serif;\n  font-size: 30px;\n  text-align: center;\n  margin-bottom: 20px;\n  ;\n}\n\nh2 {\n  font-family: 'Dancing Script', serif;\n  font-size: 2.2rem;\n  margin-bottom: 20px;\n}\n\nh3 {\n  font-family: 'Cinzel', serif;\n  font-weight: 600;\n  font-size: 18px;\n  text-transform: uppercase;\n}\n\nh4 {\n  font-family: 'Cinzel', serif;\n  font-weight: 400;\n  text-transform: uppercase;\n}\n\n.italic-semibold {\n  font-family: 'Cormorant Garamond', serif;\n  font-weight: 600;\n  font-style: italic;\n}\n\n.subtitle {\n  font-family: 'Dancing Script', serif;\n  font-size: 40px;\n  color: #030303;\n}\n\n/********************************************/\n/*                    Base                  */\n/********************************************/\n#root {\n  background: linear-gradient(to bottom, #201F41 0%, #201F41 1375px, #030303 2000px);\n}\n\n.beige {\n  color: #F3ECD2\n}\n\n.app {\n  width: 100%;\n  min-height: 100vh;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: top;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.text {\n  background-color: #dfc6a9;\n  color: #030303;\n  padding: 20px;\n}\n\n/* Parchemin (images générées par scripts/parchemin.py) : le bloc garde une bordure transparente\n   pour réserver la place du cadre ; ::before pose le papier (img/papier_parchemin.jpg), qui passe sous\n   la partie intérieure du cadre sans atteindre la déchirure ; ::after dessine le cadre déchiré\n   (img/cadre_parchemin.webp, coins 87x119, bord intérieur transparent) par-dessus.\n   --papier-pos / --papier-sens : décalage et retournement du papier tirés au hasard pour chaque bloc\n   (BackgroundWrapper.js), pour que deux blocs ne montrent pas le même dessin. */\n.fondParchemin {\n  --parchemin-haut: 70px;  /* épaisseur du cadre */\n  --parchemin-cote: 51px;\n  --papier-haut: 22px;     /* retrait du papier depuis le bord extérieur du cadre */\n  --papier-cote: 26px;\n  position: relative;\n  isolation: isolate;      /* les pseudo-éléments en z-index -1 restent sous le contenu du bloc */\n  color: #030303;\n  padding: 10px 25px;\n  border: solid transparent;\n  border-width: var(--parchemin-haut) var(--parchemin-cote);\n}\n\n.fondParchemin::before,\n.fondParchemin::after {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.fondParchemin::before {\n  inset: calc(var(--papier-haut) - var(--parchemin-haut)) calc(var(--papier-cote) - var(--parchemin-cote));\n  background: #dfceb0 url('/public/img/papier_parchemin.jpg') var(--papier-pos, 0 0);\n  scale: var(--papier-sens, 1 1);\n}\n\n.fondParchemin::after {\n  inset: calc(-1 * var(--parchemin-haut)) calc(-1 * var(--parchemin-cote));\n  border-style: solid;\n  border-width: var(--parchemin-haut) var(--parchemin-cote);\n  border-image: url('/public/img/cadre_parchemin.webp') 119 87 / var(--parchemin-haut) var(--parchemin-cote) round;\n}\n\n.fondParchemin .row {\n  margin: 20px auto;\n}\n\n.textSpe {\n  background-color: #dfc6a9;\n  margin-top: -80px;\n  padding-top: 80px;\n  padding-bottom: 80px;\n  margin-bottom: -80px;\n  z-index: -1;\n}\n\n.espaceHaut {\n  height: 38vh;\n}\n\n.codeBonus .espaceHaut {\n  height: 8vh;\n}\n\n@media (max-width: 992px) {\n  .codeBonus .espaceHaut {\n    height: 5vh;\n  }\n}\n\nfooter {\n  border-top: 1px solid #fff;\n  padding-top: 25px;\n  margin-top: 50px;\n}\n\nfooter .container {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n  margin-bottom: 10px;\n}\n\n.footerSecondaire {\n  background-color: #dfc6a9;\n  color: #030303;\n  padding: 2px;\n}\n\n.footerBoutique {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.rowIcons {\n  margin-top: 20px;\n}\n\n.enigmas-buttonsaaa {\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n/********************************************/\n/*                    Base                  */\n/********************************************/\n.mr-2 {\n  margin-right: .5rem !important;\n}\n\n/********************************************/\n/*                 BOUTON                   */\n/********************************************/\n.link-capsule {\n  border: 1px solid gold;\n  border-radius: 20px;\n  padding: 0 10px;\n}\n\n.btn-right-cut {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\nbutton,\n.btn {\n  /*couleurs de base pour bouton fond noir*/\n  /*height: 40px;*/\n  /* Hauteur fixe pour chaque bouton */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 5px 0px 15px;\n  padding: 8px 35px;\n  border-radius: 50px;\n  color: #F3ECD2;\n  background-color: #030303;\n  border: 1px solid #DAB166;\n  text-align: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.btn:hover {\n  color: #030303;\n  background-color: #DAB166;\n  border: 1px solid #030303;\n}\n\n.btn.btnBeige {\n  color: #DE9709;\n  background-color: #F3ECD2;\n  border: 1px solid #DE9709;\n}\n\n.btn.btnOrange {\n  color: #030303;\n  background-color: #DAB166;\n  border: 1px solid #030303;\n}\n\n.btnIcon {\n  padding: 8px 10px 6px;\n  border: 1px solid #DAB166;\n  border-radius: 50px;\n  color: #dfc6a9;\n}\n\n.btnIcon:hover {\n  background-color: #DAB166;\n  color: #030303;\n}\n\n/********************************************/\n/*              Responsive                  */\n/********************************************/\n@media (max-width:1400px) {\n  .espaceHaut {\n    height: 35vh;\n  }\n}\n\n@media (max-width:1200px) {\n  .espaceHaut {\n    height: 25vh;\n  }\n}\n\n@media (max-width:992px) {\n  .espaceHaut {\n    height: 5vh;\n  }\n}\n\n@media (max-width: 767px) {\n  .fondParchemin {\n    --parchemin-haut: 42px;\n    --parchemin-cote: 31px;\n    --papier-haut: 13px;\n    --papier-cote: 16px;\n    padding: 5px 8px;\n  }\n\n  .index-links {\n    gap: 0;\n    flex-direction: column;\n  }\n\n  footer {\n    text-align: center;\n    padding-top: 15px;\n  }\n\n  footer .btn {\n    margin: 5px auto;\n  }\n\n  .fondParchemin .row {\n    margin: 10px auto;\n  }\n\n  footer .container {\n    margin-bottom: 20px;\n  }\n\n  /********************************************/\n  /*               Page SPE                   */\n  /********************************************/\n\n  .page_fin,\n  .page_Fin {\n    background-color: black !important;\n  }\n\n  .page_fin2,\n  .page_Fin2 {\n    background-color: #16172d !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
